// React and Ant Design imports
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'

import {
    EnvironmentOutlined,
    DashboardOutlined,
    FolderOpenOutlined,
} from '@ant-design/icons';
import { Space } from 'antd';
// CSS imports
import './Dashboard/Dashboard.css';
import ColombiaMapComponent from '../Inicio/Dashboard/Dashboard';
import DashboardInicial from '../DashboardInicial/DashboardInicial';
import RepositorioDocumento from './Repositorio/RepositorioDocumento';

const Dashboard = () => {
    const [selectedComponent, setSelectedComponent] = useState('map');
    const [openDrawer, setOpenDrawer] = useState(false);

    const { slug } = useParams()

    useEffect(() => {
        if (slug === 'planespedagogicos') {
            // marca el repositorio como sección activa
            setSelectedComponent('repositorio');
            // abre el drawer
            setOpenDrawer(true);
            // si prefieres, puedes llamar directamente a tu handler:
            // handleOpenRepositorio();
        }
    }, [slug]);

    const handleOpenRepositorio = () => {
        setOpenDrawer(true);
    };

    const onCloseDrawable = () => {
        setOpenDrawer(false);
    };



    return (
        <div className="dashboard-container" style={{ textAlign: 'center', padding: '10px' }}>
            <Space style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                <button
                    className={`custom-button ${selectedComponent === "map" ? "active" : "inactive"}`}
                    onClick={() => setSelectedComponent('map')}
                >
                    <EnvironmentOutlined size={20} className="button-icon" />
                    Mapa
                </button>
                <button
                    className={`custom-button ${selectedComponent === "dashboard" ? "active" : "inactive"}`}
                    onClick={() => setSelectedComponent('dashboard')}
                >
                    <DashboardOutlined size={20} className="button-icon" />
                    Dashboard
                </button>
                <button
                    className={`custom-button ${selectedComponent === "repositorio" ? "active" : "inactive"}`}
                    onClick={handleOpenRepositorio}
                >
                    <FolderOpenOutlined size={20} className="button-icon" />
                    Repositorio documental
                </button>
            </Space>

            <div id="exportable-section">
                {selectedComponent === 'map' && <ColombiaMapComponent />}
                {selectedComponent === 'dashboard' && <DashboardInicial />}
                {<RepositorioDocumento open={openDrawer} onCloseMetodo={onCloseDrawable} initialSection={slug === 'planespedagogicos' ? slug : undefined} />}
            </div>
        </div>
    );
};

export default Dashboard;